import { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '@/hooks/useAuth'
import { Loader2 } from 'lucide-react'

interface ProtectedRouteProps {
  children: ReactNode
  requiredRole?: 'superadmin' | 'admin' | 'customer'
  redirectTo?: string
}

const ProtectedRoute = ({ 
  children, 
  requiredRole, 
  redirectTo = '/' 
}: ProtectedRouteProps) => {
  const { user, userRole, loading } = useAuth()

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <Loader2 className="h-8 w-8 animate-spin mx-auto mb-4 text-primary" />
          <p className="text-muted-foreground">Wird geladen...</p>
        </div>
      </div>
    )
  }

  if (!user) {
    return <Navigate to={redirectTo} replace />
  }

  if (requiredRole && userRole !== requiredRole) {
    // Redirect based on actual role
    const defaultRoute = userRole === 'superadmin' ? '/superadmin' : 
                        userRole === 'admin' ? '/admin' : '/kunde'
    return <Navigate to={defaultRoute} replace />
  }

  return <>{children}</>
}

export default ProtectedRoute